// extracted by mini-css-extract-plugin
export var statItem = "_jy-1";
export var statsRow = "_jy-0";